import { useState } from "react";

import { LAYOUT_NAVBAR_WIDTH, LAYOUT_NAVBAR_WIDTH_COLLAPSED } from "@/configs/layout";
import Icon from "@/utils/icons";
import { getFromLocalStorage, setToLocalStorage } from "@/utils/localStorageCache";

const NAVBAR_LOCALSTORAGE_KEY = "NAVBAR_STYLE";

export const useNavbar = () => {
  const getCollapsedFromLocalStorage = () => {
    const localStorageState = getFromLocalStorage(NAVBAR_LOCALSTORAGE_KEY);
    if (localStorageState === "true") return true;
    return false;
  };
  const setCollapsedToLocalStorage = (state: boolean) => {
    setToLocalStorage(NAVBAR_LOCALSTORAGE_KEY, state ? "true" : "false");
  };

  const [collapsedState, setCollapsedState] = useState(() => getCollapsedFromLocalStorage());

  const setCollapsed = (value: boolean) => {
    setCollapsedToLocalStorage(value);
    setCollapsedState(value);
  };

  const toggleCollapsed = () => setCollapsed(!collapsedState);

  const width = collapsedState ? LAYOUT_NAVBAR_WIDTH_COLLAPSED : LAYOUT_NAVBAR_WIDTH;
  const icon = collapsedState ? <Icon.GO_FORWARD_CHEVRON /> : <Icon.GO_BACK_CHEVRON />;

  return {
    collapsed: collapsedState,
    setCollapsed,
    toggleCollapsed,
    width,
    icon,
  };
};
